import { render, staticRenderFns } from "./purifyinStorageHistory.vue?vue&type=template&id=9d7aa480&scoped=true&"
import script from "./purifyinStorageHistory.vue?vue&type=script&lang=js&"
export * from "./purifyinStorageHistory.vue?vue&type=script&lang=js&"
import style0 from "./purifyinStorageHistory.vue?vue&type=style&index=0&id=9d7aa480&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7aa480",
  null
  
)

export default component.exports